/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SageSyncAnalysisTable_viewer = {
    readonly id: string;
    readonly missionControlData: {
        readonly companySyncAnalysis: {
            readonly id: string;
            readonly companyId: number;
            readonly syncDate: number;
            readonly entries: ReadonlyArray<{
                readonly id: string;
                readonly companyAnalysisId: number;
                readonly forecastCompanyId: number;
                readonly sageEntityRecordNumber: number | null;
                readonly forecastEntityId: number | null;
                readonly entityType: string;
                readonly relevancy: string;
                readonly description: string;
            } | null> | null;
            readonly supportedIssueHandlers: ReadonlyArray<{
                readonly entityType: string;
                readonly relevancy: string;
            } | null> | null;
        } | null;
    } | null;
    readonly " $refType": "SageSyncAnalysisTable_viewer";
};
export type SageSyncAnalysisTable_viewer$data = SageSyncAnalysisTable_viewer;
export type SageSyncAnalysisTable_viewer$key = {
    readonly " $data"?: SageSyncAnalysisTable_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SageSyncAnalysisTable_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityType",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relevancy",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "companyId",
      "type": "Int"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "analysisId",
      "type": "Int"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SageSyncAnalysisTable_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "MissionControlDataType",
      "kind": "LinkedField",
      "name": "missionControlData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "analysisId",
              "variableName": "analysisId"
            },
            {
              "kind": "Variable",
              "name": "companyId",
              "variableName": "companyId"
            }
          ],
          "concreteType": "MissionControlSageSyncAnalysisType",
          "kind": "LinkedField",
          "name": "companySyncAnalysis",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "companyId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "syncDate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "MissionControlSageSyncAnalysisEntryType",
              "kind": "LinkedField",
              "name": "entries",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "companyAnalysisId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "forecastCompanyId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sageEntityRecordNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "forecastEntityId",
                  "storageKey": null
                },
                (v1/*: any*/),
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "MissionControlSageSyncAnalysisIssueHandlerType",
              "kind": "LinkedField",
              "name": "supportedIssueHandlers",
              "plural": true,
              "selections": [
                (v1/*: any*/),
                (v2/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = 'd58ff8f207523e9c61d602227cef1fd6';
export default node;
